import { defaultEmployeeFormValues, EmployeeFormValues } from "../common/EmployeeFormValues";
import { defaultPfmlFormValues, PfmlFormValues } from "./PfmlFormValues";
import { ChildRelationship } from "../enums/ChildRelationship";
import { MilitaryLeaveReason } from "../enums/MilitaryLeaveReason";

export type PfmlEmployeeFormValues = EmployeeFormValues & PfmlFormValues & {
    workState: string,
    workStateSameAsResidencyState: string,
    childRelationship: ChildRelationship,
    militaryLeaveReason: MilitaryLeaveReason,
    militaryRelationship: string,
    leaveTimeframe: string,
    claimDates: [{
        startDate: string,
        endDate: string
    }],
    otherBenefits: boolean,
    hipaaConsent: boolean,
    confidentialMessages: string,
    permissionContactName: string,
    relationshipType: string,
    otherRelationshipDescription: string,
    representativeAuthority: string,
    authorityDescription: string,
    authorityDocumentation: string,
    childSupportPaid?: string,
    childSupportState?: string,
    childSupportCounty?: string
}

export const defaultPfmlEmployeeFormValues = {
    ...defaultEmployeeFormValues,
    ...defaultPfmlFormValues,
    workState: '',
    workStateSameAsResidencyState: '',
    childRelationship: '',
    militaryLeaveReason: '',
    militaryRelationship: '',
    leaveTimeframe: '',
    claimDates: [{
        startDate: '',
        endDate: ''
    }],
    otherBenefits: false,
    hipaaConsent: false,
    confidentialMessages: '',
    permissionContactName: '',
    relationshipType: '',
    otherRelationshipDescription: '',
    representativeAuthority: 'No',
    authorityDescription: '',
    authorityDocumentation: '',
    childSupportPaid: '',
    childSupportState: '',
    childSupportCounty: ''
}